import { db } from '../firebase';
import { collection, getDocs, doc, setDoc, deleteDoc, query, where } from 'firebase/firestore';
import { PlatformConfig } from '../types';

export const getPlatformConfig = async (key: string): Promise<PlatformConfig | null> => {
  const configRef = collection(db, 'platform_config');
  const q = query(configRef, where('key', '==', key));
  const querySnapshot = await getDocs(q);
  if (querySnapshot.empty) return null;
  return querySnapshot.docs[0].data() as PlatformConfig;
};

export const getAllPlatformConfigs = async (): Promise<PlatformConfig[]> => {
  const configRef = collection(db, 'platform_config');
  const querySnapshot = await getDocs(configRef);
  return querySnapshot.docs.map(doc => doc.data() as PlatformConfig);
};

export const savePlatformConfig = async (config: PlatformConfig) => {
  const configRef = doc(db, 'platform_config', config.key);
  await setDoc(configRef, config);
};

export const deletePlatformConfig = async (key: string) => {
  const configRef = doc(db, 'platform_config', key);
  await deleteDoc(configRef);
};
